export default class Tab {
  tabGroup = 'js-tab-group';
  tab = 'js-tab';
  timer: any = null;

  constructor() {
    const tabs = window.document.querySelectorAll(`.${this.tab}`);
    if (tabs.length) {
      Array.from(tabs, (tab, index) => {
        tab.addEventListener('click', e => this.tabHandler((<HTMLElement>e.target)));
      });
    }
    this.hashHandler();
  }

  tabHandler(element: HTMLElement | Element) {
    const tabList = element.closest(`.${this.tabGroup}`);
    const clickedId = element.getAttribute('data-tabId');
    const allTabs = tabList.querySelectorAll(`.${this.tab}`);

    // Add active class to clicked tab
    allTabs.forEach((element: HTMLElement) => element.classList.remove('active'));
    element.classList.add('active');

    const tabIds: any = [];
    if (clickedId) {
      Array.from(allTabs, (tab: any, index: number) => {
        const id = tab.getAttribute('data-tabId');
        if (id) {
          tabIds.push(id);
        }
      });

      tabIds.forEach((id: any) => {
        const tabContent = document.getElementById(id);

        if (tabContent && tabContent.id === clickedId) {
          tabContent.classList.add('opened');

          return;
        }
        tabContent.classList.remove('opened');
      });
    }
  }

  hashHandler() {
    const hash = window.location.hash.slice(1);
    window.clearTimeout(this.timer);
    if (hash) {
      const hashInfo = hash.split('--');
      const tabId = hashInfo[0];
      const itemId = hashInfo[1];
      const tabElem = document.querySelector(`[data-tabid="${tabId}"]`);
      const ItemElement = document.getElementById(`${itemId}`);
      if (tabElem && ItemElement) {
        this.timer = window.setTimeout(() => {
          this.tabHandler(tabElem);
          $('html, body')
            .stop()
            .animate(
              {
                scrollTop: $(ItemElement).offset().top - 100
              },
              {
                duration: 1000
              }
            );
        }, 500);
      }
    }
  }
}
